module.exports = __webpack_public_path__ + "static/img/customer.1eff750f.png";